import React from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { MdBathtub } from "react-icons/md";
import { LuScale3D } from "react-icons/lu";
import { CiLocationOn } from "react-icons/ci";
import { FaBuilding } from "react-icons/fa";

function PropertyCard({ card }) {
  const href = card.propertyUrl ? `/Property/${card.propertyUrl}` : "/Property";

  const isFeatured =
    card.featured === "true" ||
    card.featured === "1" ||
    card.featured === 1 ||
    card.featured === true;

  return (
    <div className="relative m-2 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm transition-shadow duration-300 hover:shadow-md">
      <Link to={href} className="block">
        <div className="relative h-44 overflow-hidden md:h-48">
          <img
            src={card.imgUrl}
            alt={card.title}
            className="h-full w-full object-cover"
          />
          <div className="absolute left-2 top-2 flex flex-wrap items-center gap-1">
            {isFeatured ? (
              <span className="rounded px-1.5 py-0.5 text-[8px] font-extrabold uppercase leading-none tracking-wider text-[#0F172A] shadow-sm ring-1 ring-black/5 sm:text-[9px] sm:px-2 sm:py-0.5 sm:tracking-[0.12em] bg-[#FECE51]">
                Featured
              </span>
            ) : null}
            <span className="rounded px-1.5 py-0.5 text-[8px] font-extrabold uppercase leading-none tracking-wider text-white shadow-sm ring-1 ring-white/20 sm:text-[9px] sm:px-2 sm:py-0.5 sm:tracking-[0.12em] bg-gradient-to-r from-red-500 to-orange-500">
              For sale
            </span>
          </div>
          <div className="absolute right-2 top-2 rounded-full bg-white/95 p-1.5 shadow-sm">
            <FaEye className="text-red-600" size={16} />
          </div>
        </div>
        <div className="p-3 md:p-4">
          <p className="truncate text-sm font-semibold text-slate-900 md:text-[15px]">
            {card.title}
          </p>
          <div className="mt-1.5 flex items-start gap-1.5 text-gray-600">
            <CiLocationOn className="mt-0.5 h-4 w-4 shrink-0 text-red-600" />
            <p className="line-clamp-2 text-xs leading-snug md:text-[13px]">
              {card.address}
            </p>
          </div>
          <div className="mt-2.5 flex flex-wrap items-center gap-1.5 text-red-600">
            {card.callForPrice ? (
              <p className="rounded-md bg-gradient-to-r from-red-500 to-orange-500 px-2.5 py-1.5 text-sm font-semibold text-white">
                {card.callForPrice}
              </p>
            ) : (
              <>
                <p className="rounded-md bg-gradient-to-r from-red-500 to-orange-500 px-2.5 py-1.5 text-sm font-semibold text-white">
                  ₹{card.price}
                </p>
                {card.suffixPrice ? (
                  <span className="text-sm font-medium text-red-600 line-through">
                    ₹{card.suffixPrice}
                  </span>
                ) : null}
              </>
            )}
          </div>
          <div className="mt-2.5 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-gray-600 md:text-xs">
            <div className="flex items-center gap-1">
              <LuScale3D className="text-[#727272]" size={14} />
              <span>Area: {card.area} sqft</span>
            </div>
            <div className="flex items-center gap-1">
              <MdBathtub className="text-[#727272]" size={14} />
              <span>Bath: {card.bathroom}</span>
            </div>
            <div className="flex items-center gap-1">
              <FaBuilding className="text-[#727272]" size={14} />
              <span>Project Extent: {card.parking}</span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default PropertyCard;
